// extracted by mini-css-extract-plugin
export default {"header":"Header_header__tFmhi","mainimage":"Header_mainimage__tF04l"};